var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"app-font-icon",class:("icon-" + _vm.name + " " + (_vm.isClickable ? 'hand-pointer' : 'hand-default')),style:({ fontSize: _vm.size, color: _vm.color })},'div',Object.assign({}, _vm.resetProps),false))}
var staticRenderFns = []

export { render, staticRenderFns }